module.exports = __webpack_public_path__ + "img/steele-logo.4426de29.svg";